import FacturesController from './factures.controller';

export default {
    template: require('./factures.tpl.html'),
    controller: FacturesController
};
